import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"

import { Button, Card, Checkbox, Tooltip } from "components"
import classes from "./LsmSelectedFoods.module.scss"

const LsmSelectedFoods = props => {
  const {
    selectedFoods,
    setSelectedFoods,
    setShowSelectedFoods
  } = props

  const initialFormState = { ...selectedFoods }

  const [t] = useTranslation()

  const [form, setForm] = useState(initialFormState)

  const handleDeselectAll = () => {
    setForm({})
  }

  const handleSelectAll = () => {
    setForm(initialFormState)
  }

  const handleDone = () => {
    setSelectedFoods(form)

    setShowSelectedFoods(false)
  }

  const handleSelectFood = (checked, food) => {
    setForm(prev => {
      const previousForm = { ...prev }

      if (checked) {
        previousForm[food._id] = food
      } else {
        delete previousForm[food._id]
      }

      return previousForm
    })
  }

  const foods = Object.values(selectedFoods)

  const showDeselect =
    Object.keys(form).length !== 0

  return (
    <Fragment>
      <div className={classes["container"]}>
        {foods.map(food =>
          <Card
            key={food._id}
            onClick={() => handleSelectFood(!form[food._id], food)}
            className={classes["card"]}
          >
            <Tooltip title={food.name}>
              <span className={classes["food-name"]}>
                {food.name}
              </span>
            </Tooltip>
            <Checkbox
              checked={!!form[food._id]}
              onChange={() => { }}
            />
          </Card>
        )}
      </div>
      <div className={classes["footer"]}>
        {showDeselect
          ?
          <Button
            color="danger"
            className={classes["button"]}
            onClick={handleDeselectAll}
          >
            {t("حذف_همه_کالا_ها")}
          </Button>
          :
          <Button
            color="info"
            className={classes["button"]}
            onClick={handleSelectAll}
          >
            {t("انتخاب_همه_کالا_ها")}
          </Button>
        }
        <div>
          <Button
            color="danger"
            className={classes["button"]}
            onClick={() => setShowSelectedFoods(false)}
          >
            {t("بازگشت")}
          </Button>
          <Button
            onClick={handleDone}
            color="success"
          >
            {t("تایید")}
          </Button>
        </div>
      </div>
    </Fragment>
  )
}

export default LsmSelectedFoods